<mat-sidenav-container class="sidenav-container" cdkScrollable>
  <mat-sidenav
    #drawer
    class="sidenav"
    fixedInViewport
    [attr.role]="(isHandset$ | async) ? 'dialog' : 'navigation'"
    [mode]="(isHandset$ | async) ? 'over' : 'side'"
    opened="false">
    <mat-toolbar>
      <div class="sidenav-title">My Ganahl</div>
    </mat-toolbar>
    <mat-nav-list>
      <a
        mat-list-item
        *ngFor="let link of navLinks"
        [routerLink]="link.path"
        (click)="drawer.close()"
        routerLinkActive>
        <mat-icon matListItemIcon>{{ link.icon }}</mat-icon>
        <div matListItemTitle>{{ link.title }}</div>
      </a>
    </mat-nav-list>
    <div class="sidenav-release">Release version {{ version }}</div>
  </mat-sidenav>
  <mat-sidenav-content>
    <mat-toolbar class="gnl-nav-menu-container" color="primary">
      <nav
        class="gnl-nav-mobile-container"
        *ngIf="(isHandset$ | async) === true">
        <button
          type="button"
          aria-label="Toggle sidenav"
          mat-icon-button
          (click)="drawer.toggle()">
          <mat-icon aria-label="Side nav toggle icon">menu</mat-icon>
        </button>
        <a class="gnl-logo-tab-link-mobile" [routerLink]="'/secure/dashboard'">
          <img src="/assets/img/logo-white.gif" alt="logo" />
        </a>
        <div></div>
      </nav>

      <nav
        *ngIf="(isHandset$ | async) === false"
        mat-tab-nav-bar
        fitInkBarToContent="true"
        [disablePagination]="(isLargeScreen$ | async) === true"
        class="gnl-nav-menu"
        [tabPanel]="tabPanel">
        <a class="logo-tab-link" [routerLink]="'/secure/dashboard'">
          <img src="/assets/img/logo-white.gif" alt="logo" />
        </a>

        <a
          mat-tab-link
          class="gnl-nav-menu-item"
          *ngFor="let link of navLinks"
          [routerLink]="link.path"
          routerLinkActive
          #rla="routerLinkActive">
          <mat-icon matPrefix class="menu-icon">{{ link.icon }}</mat-icon>
          <span class="menu-title">{{ link.title }}</span>
        </a>
      </nav>
    </mat-toolbar>
    <div class="gnl-breadcrumb-container">
      <gnl-bread-crumb></gnl-bread-crumb>
    </div>
    <section class="gnl-content">
      <router-outlet></router-outlet>
      <mat-tab-nav-panel #tabPanel></mat-tab-nav-panel>
    </section>
    <section class="public-footer">
      <gnl-footer></gnl-footer>
    </section>
  </mat-sidenav-content>
</mat-sidenav-container>
